import { render } from "./AppHeaderPropsCmp.vue?vue&type=template&id=1b57b9dc"
import script from "./AppHeaderPropsCmp.vue?vue&type=script&lang=js"
export * from "./AppHeaderPropsCmp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__